<template>
  <ManagerCompanyShow :company-id="companyId" />
</template>

<script lang="ts" setup>
  // Types
  import type { RouteLocationNormalizedLoaded } from 'vue-router';

  // Components
  import ManagerCompanyShow from '~/modules/manager/company/show/ManagerCompanyShow.vue';

  definePageMeta({
    layout: 'manager',
    middleware: 'manager-auth',
  });

  const route: RouteLocationNormalizedLoaded = useRoute();

  const companyId: ComputedRef<number | null> = computed<number | null>(() =>
    route.params.id ? Number(route.params.id) : null
  );
</script>
